var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('input',{attrs:{"type":"hidden","name":"utm-campaign-url"}}),_c('input',{attrs:{"type":"hidden","name":"utm-cookie-url"}})])}]

export { render, staticRenderFns }